import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

export const productSliceSelector = (state: RootState) => state.product;

export const productInfoSelector = createSelector(productSliceSelector, (state) => state.productInfo);
export const productIdSelector = createSelector(productInfoSelector, (state) => state.id || '');
export const productVersionSelector = createSelector(productInfoSelector, (state) => state.version || null);
